// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class EquipmentTypeResource extends Resource {
    basePath: string = 'services/equipmentTypes/';

    objectPath: string = 'services/equipmentTypes/{ident}/';
}
